import { UserStateEnum } from "./userStateEnum";

export const entryTypeOptions = [
    { key: UserStateEnum.Active, text: "Activo" },
    { key: UserStateEnum.Inactive, text: "Inactivo" },
  ];
  
  export const getUserStateText = (key: number) => {
    return entryTypeOptions.find((type) => type.key === key)?.text || "";
  };

  export const getUserState = (text: string) => {
    return entryTypeOptions.find((type) => type.text === text)?.key || 0;
  };